import { Box, type SxProps } from '@mui/material';
import { ThemePalette } from 'mui.theme';
import { CLIENT_THEME, clientThemePalette } from 'utils/clientTheme';

interface Props {
  children?: JSX.Element | JSX.Element[];
  style?: SxProps;
  enableDarkTheme?: boolean;
}

export const ToolbarContainer = ({
  children,
  style,
  enableDarkTheme = false,
}: Props) => {
  const palette = enableDarkTheme
    ? clientThemePalette[CLIENT_THEME].dark
    : clientThemePalette[CLIENT_THEME].light;
  return (
    <Box
      sx={{
        padding: '10px 20px',
        boxShadow: '0px 0px 3px #00000029',
        backgroundColor: enableDarkTheme
          ? palette.toolBarBackground
          : palette.toolBarBackground,
        borderRadius: '5px 5px 0px 0px',
        display: 'flex',
        alignItems: 'center',
        maxHeight: '44px',
        color: palette.textPrimary,
        ...style,
      }}
    >
      {children}
    </Box>
  );
};
